import moment from 'moment-timezone';
import store from '@/store';
import router from '@/router';
import axios from 'axios';
import { BACK_URL } from '../utils/const';

let currentRefreshPromise = null;
const refreshTokenQueue = () => {
  const refreshToken = localStorage.getItem('refresh-token');
  if (currentRefreshPromise === null) {
    currentRefreshPromise = axios.post(`${BACK_URL}/auth/refreshToken`, {
      RefreshToken: refreshToken,
      KeepAlive: store.getters.KeepAlive,
      TimeZone: moment.tz.guess(),
    }).then((resp) => {
      localStorage.setItem('user-token', resp.data.UserToken);
      localStorage.setItem('refresh-token', resp.data.RefreshToken);
    }).catch((err) => Promise.reject(err)).finally(() => {
      currentRefreshPromise = null;
    });
  }
  return currentRefreshPromise;
};

export default function(error) {
  const refreshToken = localStorage.getItem('refresh-token');
  if (error.config && error.response && error.response.status === 403 && refreshToken) {
    return refreshTokenQueue().then(() => {
      error.config.headers.Authorization = `Bearer ${localStorage.getItem('user-token')}`;
      return axios.request(error.config)
        .then((resp) => resp)
        .catch((_) => Promise.reject(error.response));
    }).catch(() => {
      store.dispatch('LOGOUT');
      store.dispatch('SHOW_SESSION_BLOCK', true);
      router.push('/auth');
      return Promise.reject(error.response);
    });
  } else {
    return Promise.reject(error.response);
  }
}
